module.exports = __webpack_public_path__ + "media/images/icons/rooms/toilet-d77b465f0ee1174d160e7e5ec4fc6053.svg";